import { Typography } from "@material-ui/core";
import React, { useState } from "react";



export const Unauthorised = () =>{
    return(
    <Typography> you are not authorised to access the web site. Please contact admin</Typography>
    )
}